(window.dataLayer = window.dataLayer || []),
  console.log("datalayer.js v=221120221350 initialized!"),
  document.querySelector(".add-to-cart").addEventListener("click", function () {
    var e;
    (e = {
      event: "add_to_cart",
      action: "click",
      label: document.querySelector(".product-single__title").innerText.trim(),
      pixel_id: 0x64b58aea9ab06,
    }),
      dataLayer.push(e);
  });
//# sourceMappingURL=datalayer.js.map
